// extracted by mini-css-extract-plugin
export default {"root":"Production_root__yYQLr","light":"Production_light__FgZEY","dark":"Production_dark__cg99v"};